import axios from "axios";
import {toast} from "react-toastify";
import {hideCart} from "../utils/functions";

export const verifyPhoneAgain = (data: any) => {
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/verify/phone", data)
        .then((response) => response.data)
        .then((data) => {

        })
        .catch((e) => {
            toast.error(e.response.data.message);
            console.log(e);
        })
};

export const verifyPhone = (data: any, checkPhoneState: (state: boolean) => {}) => {
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/verify/phone", data)
        .then((response) => response.data)
        .then((data) => {
            // toast.info(data.message);
            checkPhoneState(true)
        })
        .catch((e) => {
            toast.error(e.response.data.message);
            console.log(e);
        })
};

export const sentCart = async (cartItems: any, userCartInfo: any, cartTotal: any, dispatch: any) => {
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/request", {
            cartItems: cartItems,
            userCartInfo: userCartInfo,
            cartTotal: cartTotal
        })
        .then((response) => response.data)
        .then((data) => {
            toast.info("Заказ успешно создан, необходимо произвести оплату");
            dispatch({
                type: "SET_CART_TOTAL",
                cartTotal: 0,
            });
            dispatch({
                type: "SET_CART_ITEMS",
                cartItems: []
            });
            dispatch({
                type: "SET_USER_CART_INFO",
                userCartInfo: {}
            });
            hideCart(dispatch)
        })
        .catch((e) => {
            toast.error("Не удалось создать заказ");
            console.log(e);
        })
};

export const verifyCode = async (cartData: any, verificationCode: string, checkoutPaymentState: (state: boolean) => {}, dispatch: any) => {
    if (cartData.code === "") {
        toast.info("Введите код");
        return
    }
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/verify/code", {
            phone: cartData.userCartInfo.phone,
            code: cartData.code
        })
        .then((response) => response.data)
        .then((data) => {
            toast.info(data.message);
            dispatch({
                type: "SET_VERIFICATION_CODE",
                verificationCode: cartData.code,
            });
            checkoutPaymentState(true)
        })
        .catch((e) => {
            console.log("Неверный код");
            toast.error(e.response.data.message);
            console.log(e);
        })
};

export const fetchSchedule = (dispatch: any) => {
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/schedule")
        .then((response) => response.data)
        .then((data) => {
            dispatch({
                type: "SET_SCHEDULE",
                schedule: data,
            });
        })
        .catch((e) => {
            toast.error(e.response.data.message);
            console.log(e);
        })
};